<div>
       <button  autofocus id="foco"  [disabled]="control.disabled || disabled">
       <mat-icon style="font-size: 21px;" *ngIf="control?.value"  (click)="resetValue()">backspace</mat-icon> 
       <mat-icon style="font-size: 21px;" *ngIf="!control?.value" >expand_more</mat-icon> 
      </button>  
        
</div>